<template>
  <div class="logout">
    正在注销，请稍后...
  </div>
</template>

<script>
  export default {
    name: "logout",
    mounted(){
      this.$fetch.user.user_logout().then((data)=>{
        this.$store.commit('RemoveUser');
        this.$router.push({name: 'Index_index'});
      }).catch(()=>{
      })
    }
  }
</script>

<style scoped lang="less">
  .logout {
    padding: 10px;
    text-align: center;
    height: 85vh;
  }
</style>
